import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {CommonDataService} from 'app/services/common-data.service';

import * as fileSaver from "file-saver";
import {TranslateService} from "@ngx-translate/core";
import { CommonService } from 'app/services/common.service';
import { Versions } from 'app/shared/models/vesions';


@Component({
    selector: 'component-info',
    templateUrl: './component-info.component.html',
    styleUrls: ['./component-info.component.css']
})
export class ComponentInfoComponent implements OnInit{
    constructor(public readonly commonData: CommonDataService,
                public translateService: TranslateService,
                elementRef: ElementRef,
                @Inject(PLATFORM_ID) platformId: any,
                public readonly commonService: CommonService,
    ){
        this.tooltipEnable = new Function('', '$("[data-toggle=tooltip]").tooltip({ boundary: "window" });');
        this.translateService = this.commonData.translateService;
    }

    @Output() change: EventEmitter<any>;

    @Input() public inputData: string;
    @Input() public direction: string;
    @Input() public color?: string;
    @Input() public ico?: string;
    @Input() public link: string;
    @Input() public moduleVer?: string;
    @Input() public useClientName: boolean;
    private readonly tooltipEnable: Function;
    private name: string;
    private versions: Versions;
    public loading: boolean;

    async ngOnInit() {
        this.versions = new Versions();
        if (!this.color){
            this.color = '#21606b';
        }
        if (!this.ico){
            this.ico = 'fa-info-circle';
        }

        let link: string = await this.translateService.get(this.link).toPromise();

        this.commonService.getClientName().subscribe( data => {
            if (!data || !data.success){
                return;
            }
            this.name = data.clientName
                ? this.moduleVer
                    ? `${link}_${this.versions[this.moduleVer]}.pdf`
                    : `${link}.pdf`
                : '';
            this.link = data.clientName && this.useClientName
                ? `/assets/inst/${data.clientName}_${link}.pdf`
                : `/assets/inst/${link}.pdf`;
            // console.log(this.link, 'link')
        });
        this.commonData.translateService.get(this.inputData).subscribe( r => {
            this.inputData = r;
            setTimeout(() => {
                $('.info-component').tooltip();
            },1)
        })
    }

    public saveInstruction = (): void => {
        // console.log(this.link, 'this.link')
        if (this.loading){
            return
        }

        if (this.link){
            this.loading = true;
            this.commonService.saveFile(this.link).subscribe(blob =>{
                this.loading = false;
                fileSaver.saveAs(blob, this.name);
            }, e =>{
                this.loading = false;
                if (!e.message) {
                    this.translateService.get('InstructionNotAvailable')
                        .subscribe(error => this.commonData.showErrors([error]))
                } else {
                    this.commonData.showErrors([e.message]);
                }
            });
        } else this.translateService.get('InstructionNotAvailable')
            .subscribe(error => this.commonData.showErrors([error]));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/component-info.component/component-info.component.ts